import React from 'react'
import Style from '../mappingUi.module.css'

const StatusBanner = ({ status, onDismiss }) => {
    if (!status) {
        return null
    }

    return (
        <div
            className={[Style.banner, status.result ? Style.bannerSuccess : Style.bannerError].join(' ')}
            role={status.result ? 'status' : 'alert'}
        >
            <i className={status.result ? 'uil-check-circle' : 'uil-exclamation-triangle'} aria-hidden="true" />
            <span className={Style.bannerText}>{status.message}</span>
            {onDismiss ? (
                <button type="button" className={Style.bannerClose} aria-label="Dismiss message" onClick={onDismiss}>
                    &times;
                </button>
            ) : null}
        </div>
    )
}

export default StatusBanner
